module.exports = __webpack_public_path__ + "img/9788963191270.dd8dd4d5.jpg";